import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

const ProductCardSkeleton = () => {
	return (
		<>
			<Skeleton variant="rectangular" height={212} />
			<Typography variant="h5" gutterBottom>
				<Skeleton />
			</Typography>
			<Typography component="div" gutterBottom>
				<Skeleton width={120} />
			</Typography>
			<Typography component="div">
				<Skeleton width={80} />
			</Typography>
		</>
	);
};

export default ProductCardSkeleton;
